import { dataShoppingCart } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShoppingCart = /*#__PURE__*/createIcon(dataShoppingCart)
export default IconShoppingCart
